var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockFilled = function SvgLockFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 52",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3625 24.6992H10.6076V13.5378C10.6076 6.07328 16.609 0 23.9851 0C31.3612 0 37.3625 6.07328 37.3625 13.5378V24.6992ZM15.1038 20.1491H32.8674V13.5378C32.8674 8.58154 28.8837 4.55013 23.9862 4.55013C19.0886 4.55013 15.105 8.58154 15.105 13.5378L15.1038 20.1491Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5978 52H9.37219C7.51299 52 6 50.4689 6 48.5874V23.5617C6 21.6802 7.51299 20.1491 9.37219 20.1491H38.5978C40.457 20.1491 41.97 21.6802 41.97 23.5617V48.5874C41.97 50.4689 40.457 52 38.5978 52ZM10.4963 47.4499H37.4737V24.6992H10.4963V47.4499Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0091 24H9.76575V48H38.0091V24ZM21.8557 41.7622H26.1186C26.7684 41.7622 27.2631 41.1718 27.1563 40.5234L26.2355 34.937L26.5413 33.6971C26.9573 32.0158 25.7004 30.3869 23.9871 30.3869C22.2739 30.3869 21.017 32.0158 21.433 33.6982L21.7387 34.937L20.818 40.5234C20.7112 41.1718 21.2059 41.7622 21.8557 41.7622Z"
  })));
};
export default SvgLockFilled;